import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { DomUtils, EnterArrowIcon, SearchIcon, UpDownArrowsIcon, withWidth } from '@onsolve/onsolve-ui-components';

import { globalSearchTranslations } from 'translations';


import SearchCloseButton from './SearchCloseButton';

class SearchModal extends Component {
    constructor(props) {
        super(props);

        this.input = React.createRef();
    }

    handleOnOpened = () => {
        this.focusInput();
    };

    focusInput = () => {
        DomUtils.setFocus(this.input);
    };

    handleChange = e => {
        const { onInputChange } = this.props;

        if (onInputChange) {
            onInputChange(e);
        }
    };

    handleKeyDown = e => {
        const { onKeyDown } = this.props;

        onKeyDown(e, e.target.classList.contains('onsolve-icon-btn'));
    };

    render() {
        const {
            forwardedCloseRef,
            classes,
            isOpen,
            size,
            onClose: handleClose,
            onClosed,
            onExit,
            onFocus: handleInputFocus,
            content,
            value,
            withNavigation,
            intl
        } = this.props;

        const rootClasses = classNames('onsolve-menu-search', classes.root);
        const bodyClasses = classNames('onsolve-menu-search__body', classes.body);
        const footerClasses = classNames('onsolve-menu-search__footer', classes.footer);
        return (
            <Modal
                className={rootClasses}
                isOpen={isOpen}
                onOpened={this.handleOnOpened}
                toggle={handleClose}
                onClosed={onClosed}
                onExit={onExit}
                centered
                zIndex="auto"
                backdrop={true}
                size={size}
            >
                <div className={classNames('modal-header', 'onsolve-menu-search__header')}>
                    <SearchIcon size="lg" className="onsolve-menu-search-magnify-icon" color="secondary" />
                    <div className="onsolve-menu-search-field__container">
                        {!value && (
                            <span className="onsolve-menu-search-field__placeholder">
                                {intl.data[globalSearchTranslations.ng_globalSearch_searchPage.id]}
                            </span>
                        )}
                        <input
                            type="text"
                            ref={this.input}
                            value={value}
                            onChange={this.handleChange}
                            onFocus={handleInputFocus}
                            onKeyDown={this.handleKeyDown}
                            className="onsolve-menu-search-field__input"
                        />
                    </div>
                    <SearchCloseButton ref={forwardedCloseRef} onClose={handleClose} onKeyDown={this.handleKeyDown} />
                </div>
                {content ? <ModalBody className={bodyClasses}>{content}</ModalBody> : null}
                <ModalFooter className={footerClasses}>
                    <div className="onsolve-menu-search__footer__message-block">
                        {withNavigation && (
                            <Fragment>
                                <span>
                                    <UpDownArrowsIcon color="secondary" />
                                    {intl.data[globalSearchTranslations.ng_globalSearch_toNavigate.id]}
                                </span>
                                <span className="mx-3">
                                    <EnterArrowIcon color="secondary" />
                                    {intl.data[globalSearchTranslations.ng_globalSearch_toSelect.id]}
                                </span>
                            </Fragment>
                        )}

                        <span className="text-secondary">esc</span>
                        <span className="ml-1 mx-2">
                            {intl.data[globalSearchTranslations.ng_globalSearch_toDismiss.id]}s
                        </span>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}

SearchModal.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string,
        header: PropTypes.string,
        body: PropTypes.string,
        footer: PropTypes.string
    }),
    content: PropTypes.element,
    forwardedCloseRef: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onClosed: PropTypes.func,
    onExit: PropTypes.func,
    onFocus: PropTypes.func,
    onInputChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    withNavigation: PropTypes.bool,
    intl: PropTypes.object
};

SearchModal.defaultProps = {
    classes: {},
    size: 'lg'
};

export default withWidth()(SearchModal);
